import { Shield, Cpu, Crosshair, Star, Layers, Target, Wrench, Award, RefreshCw,
         FileCheck2, Bell, ClipboardCheck, BookOpenCheck, Brain, FileBadge } from "lucide-react";

export const TRACKS = [
  { id: "operator", name: "Operator", tag: "TRK-01", icon: Shield, color: "var(--cyan)", line: "Defend the perimeter.",
    desc: "Front-line cyber operators executing defensive playbooks under contact.", img: "https://images.pexels.com/photos/29656048/pexels-photo-29656048.jpeg" },
  { id: "engineer", name: "Engineer", tag: "TRK-02", icon: Cpu, color: "var(--amber)", line: "Engineer resilience.",
    desc: "Builds, hardens, and sustains the secure platforms warfighters rely on." },
  { id: "hunter", name: "Hunter / Analyst", tag: "TRK-03", icon: Crosshair, color: "var(--green)", line: "Hunt the adversary.",
    desc: "Proactive threat hunters and analysts who pursue intrusions to closure." },
  { id: "leader", name: "Leader", tag: "TRK-04", icon: Star, color: "var(--red)", line: "Command the mission.",
    desc: "Cyber leaders translating commander's intent into mission-ready operations.", img: "https://images.pexels.com/photos/14357096/pexels-photo-14357096.jpeg" },
];

export const STAGES = [
  { n: "01", name: "Foundation", icon: Layers, desc: "Doctrine, telemetry, ATT&CK fluency." },
  { n: "02", name: "Specialization", icon: Target, desc: "Track-specific tradecraft and tools." },
  { n: "03", name: "Simulation", icon: Wrench, desc: "Live-fire range against a red cell." },
  { n: "04", name: "Certification", icon: Award, desc: "Performance-based qualification board." },
  { n: "05", name: "Recertification", icon: RefreshCw, desc: "Annual readiness renewal." },
];

// B2B-focused outcomes for L&D managers at defence contractors.
export const MEASURES = [
  { v: "92%", k: "First-Try Cert Pass", d: "Trainees passing certification boards on first attempt." },
  { v: "47", k: "Days to Mission-Ready", d: "Median time from intake to first qualified assignment." },
  { v: "100%", k: "Auto-Recert Coverage", d: "Expiring credentials auto-enroll trainees — zero admin." },
  { v: "0 hrs", k: "Audit Prep", d: "Compliance pack PDFs render on demand for any tender response." },
];

export const HERO_STATS = [
  { k: "ISM/E8 MAPPED", v: "YES" },
  { k: "MITRE COVERAGE", v: "TRACKED" },
  { k: "BADGES", v: "VERIFIABLE" },
  { k: "COMPLIANCE PDF", v: "ON-DEMAND" },
];

// Pain points L&D managers at defence contractors face — drives the
// "Built for…" section just below the hero.
export const LD_PAIN_POINTS = [
  {
    icon: ClipboardCheck,
    title: "Tender Evidence on Demand",
    body: "Generate a signed compliance pack PDF — ISM controls, Essential Eight maturity, MITRE coverage, AI-graded practicals — and attach it to ADF or DoD tender responses without a six-week audit project.",
  },
  {
    icon: Bell,
    title: "Auto-Recert, Zero Slippage",
    body: "Annual qualification renewals enroll automatically the moment a credential enters its 30-day expiry window. Squad leaders see the watchlist on their dashboard the day the clock starts.",
  },
  {
    icon: Brain,
    title: "AI-Graded Practicals",
    body: "Trainees run real exercises in an in-browser code editor. Sentinel grades against a published rubric and returns strengths, weaknesses, and a defensible score — not a completion certificate.",
  },
  {
    icon: FileBadge,
    title: "Verifiable Open Badges",
    body: "Every credential is a cryptographically-signed Open Badge with a public verify URL. Hiring managers and procurement officers can check the signature in seconds — no portal login required.",
  },
];

// Concrete artifacts inside the compliance pack — used in the
// "Inside the compliance pack" reveal section.
export const PACK_ARTIFACTS = [
  { label: "Operator identity & track", value: "Maj. Arjun Verma · Leader" },
  { label: "Verified credentials", value: "6 active · 1 expiring (18d)" },
  { label: "ISM controls covered", value: "ISM-0140 · 0420 · 0974 · 1383 · …" },
  { label: "Essential Eight maturity", value: "Patch apps L2 · App control L2 · MFA L3" },
  { label: "MITRE ATT&CK techniques", value: "T1059, T1078, T1486, T1190, T1566 …" },
  { label: "AI-graded practicals", value: "12 attempts · best 91% · median 78%" },
];
